import { Disclosure, LanguageOption, SupportedLanguage } from "./disclosure.types";

// Language options with flags
export const LANGUAGE_OPTIONS: LanguageOption[] = [
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
  { code: "zh", label: "中文", flag: "🇨🇳" },
  { code: "vi", label: "Tiếng Việt", flag: "🇻🇳" },
  { code: "so", label: "Somaliyeed", flag: "🇸🇴" },
  { code: "hmn", label: "Hmoob", flag: "🇱🇦" },
];

export const DEFAULT_LANGUAGE: SupportedLanguage = "en";

export const getDisclosureContent = (
  disclosure: Disclosure,
  language: SupportedLanguage,
): Disclosure["content"][SupportedLanguage] => {
  return disclosure.content[language] || disclosure.content.en;
};

export const getLanguageOption = (code: SupportedLanguage): LanguageOption | undefined => {
  return LANGUAGE_OPTIONS.find((l) => l.code === code);
};
